import React from 'react';
import PropTypes from 'prop-types';
import { IssuesLink } from './issues-link';
import style from './style.module.less';

const StatusStats = ({ completed, total, errors, warnings, onOpenLabelBatchStatus }) => {
  return (
    <div className={style.descendent}>
      {completed}/{total}, <IssuesLink errors={errors} onOpenLabelBatchStatus={onOpenLabelBatchStatus} warnings={warnings} />
    </div>
  );
};

StatusStats.propTypes = {
  completed: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  errors: PropTypes.number.isRequired,
  warnings: PropTypes.number,
  onOpenLabelBatchStatus: PropTypes.func.isRequired,
};

export { StatusStats };
